import React, { useState } from "react";
import styles from "./Kontakt.module.css";
import {FaEnvelope, FaMapMarkerAlt, FaPhoneAlt} from "react-icons/fa";
import kontakt from './assets/kontakt.png';


const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      setStatus("Bitte füllen Sie alle Felder aus.");
      return;
    }

    setStatus("Ihre Nachricht wurde erfolgreich gesendet. Vielen Dank!");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <>

          <div
              className={styles.hero}
              style={{ backgroundImage: `url(${kontakt})` }}
          />
       <div className="wrapper">
         <section className="wrapperContent">

          <section className={styles.topSection}>

            <div className={styles.contactInfo}>
              <h1>KONTAKT</h1>
              <hr />

              <div className={styles.infoRow}>
                <div className={styles.infoIcon}>
                  <FaPhoneAlt />
                </div>
                <p>
                  <strong>Telefon: </strong>
                  <a href="tel:06927997180">069 279 971 80</a>
                </p>
              </div>

              <div className={styles.infoRow}>
                <div className={styles.infoIcon}>
                  <FaEnvelope />
                </div>
                <p>
                  <strong>Email: </strong>
                  <a href="mailto:info@iks-schule.de">info@iks-schule.de</a>
                </p>
              </div>

              <div className={styles.addressRow}>
                <div className={styles.icon}>
                  <FaMapMarkerAlt />
                </div>
                <p className={styles.address}>
                  <strong>Adresse: </strong><br />
                  <a href="https://www.google.com/maps?q=IKS+Interkulturelle+Schule+Rhein-Main,+Kaiserkronenweg+1,+60433+Frankfurt+am+Main" target="_blank">
                    IKS Interkulturelle Schule Rhein-Main, Kaiserkronenweg 1, 60433 Frankfurt am Main
                  </a>

                </p>
              </div>
            </div>


            <div className={styles.contactMap}>
              <iframe
                title="IKS Standort"
                src="https://maps.google.de/maps?hl=de&q=IKS%20%20Kaiserkronenweg+1,+60433+Frankfurt+am+Main&t=&z=14&ie=utf8&iwloc=b&output=embed"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
              ></iframe>
            </div>
          </section>
    {/*

          <section className={styles.formSection}>
            <h2>Schreiben Sie uns</h2>
            <form onSubmit={handleSubmit} className={styles.form}>
              <input
                type="text"
                name="name"
                placeholder="Ihr Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Ihre E-Mail-Adresse"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <textarea
                name="message"
                placeholder="Ihre Nachricht"
                value={formData.message}
                onChange={handleChange}
                rows={5}
                required
              />
              <button type="submit">Senden</button>
            </form>
            {status && <p className={styles.status}>{status}</p>}
          </section>
        */  }
        </section>
    </div>
     </>
  );
};


export default ContactPage;
